<template>
  <v-dialog v-model="dialog" max-width="460px" @keydown.esc="close" @click:outside="close">
    <v-card v-if="access">
      <v-card-title class="headline">
        Ajustar cuentas
        <v-spacer />
        <v-btn icon @click="close" :disabled="loading"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />

      <v-card-text class="pt-4">
        <div class="mb-2 grey--text text--darken-2">
          {{ access.companyName }} · {{ access.planName }}
        </div>

        <div class="d-flex align-center justify-center my-3">
          <v-btn icon @click="dec" :disabled="loading || target <= 0"><v-icon>mdi-minus</v-icon></v-btn>
          <v-text-field
            v-model.number="target"
            type="number"
            min="0"
            class="mx-3 centered-input"
            style="max-width: 100px"
            hide-details
            outlined
            dense
          />
          <v-btn icon @click="inc" :disabled="loading"><v-icon>mdi-plus</v-icon></v-btn>
        </div>
        <div class="text-center caption grey--text">Cuentas actuales: {{ access.totalAccounts }}</div>

        <v-alert
          v-if="confirmation"
          type="warning"
          dense
          text
          class="mt-4 mb-0"
        >
          Esta disminución desactivará
          <strong>{{ confirmation.membershipsToDeactivate }}</strong>
          membresía(s) activa(s) para ajustarse a la nueva capacidad
          ({{ confirmation.newCapacity }}). ¿Confirmar?
        </v-alert>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text @click="close" :disabled="loading">Cancelar</v-btn>
        <template v-if="can('users:manage-company-access')">
        <v-btn
          v-if="!confirmation"
          color="primary"
          :loading="loading"
          :disabled="target === access.totalAccounts || target < 0"
          @click="save(false)"
        >
          Guardar
        </v-btn>
        <v-btn
          v-else
          color="warning"
          :loading="loading"
          @click="save(true)"
        >
          Sí, desactivar y guardar
        </v-btn>
        </template>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CompaniesService from '../services/companie.service.js';
import { can } from '../utils/permissions';

export default {
  name: 'AdjustAccountsModal',
  props: {
    value: { type: Boolean, default: false },
    access: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      target: 0,
      confirmation: null
    };
  },
  computed: {
    dialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  },
  watch: {
    value(open) {
      if (open && this.access) {
        this.target = this.access.totalAccounts;
        this.confirmation = null;
      }
    }
  },
  methods: {
    can,
    inc() { this.target = Number(this.target) + 1; this.confirmation = null; },
    dec() { if (this.target > 0) { this.target = Number(this.target) - 1; this.confirmation = null; } },
    async save(confirm) {
      if (this.target < 0) return;
      this.loading = true;
      const res = await CompaniesService.updateAccessAccounts(
        this.access.id,
        Number(this.target),
        confirm
      );
      this.loading = false;
      if (res.status !== 'ok') {
        this.$emit('error', 'No se pudo ajustar las cuentas.');
        return;
      }
      if (res.data && res.data.requiresConfirmation) {
        this.confirmation = res.data;
        return;
      }
      this.$emit('saved');
      this.close();
    },
    close() {
      this.confirmation = null;
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.centered-input >>> input { text-align: center; }
</style>
